import type { MasterQuote } from '@djust-b2b/djust-front-sdk/lib/interfaces/models/quote';
import { defineStore } from 'pinia';

export const useQuoteStore = defineStore('quote', {
  state: () => ({
    quotes: [] as MasterQuote[],
    quote: {} as MasterQuote,
    quoteLines: [] as Array<{}>,
    quoteCommercialOrder: '' as string,
  }),
  getters: {
    getQuoteById: (state) => (quoteId: string) => {
      return state.quotes.find((quote) => quote.id === quoteId);
    },
  },
  actions: {
    setQuotes(quoteList: MasterQuote[]) {
      this.quotes = quoteList;
    },
    clearQuotes() {
      this.quotes = [];
    },
    addQuote(quote: MasterQuote) {
      this.quotes.push(quote);
    },
    updateQuote(quoteId: string, updatedQuote: MasterQuote) {
      const index = this.quotes.findIndex((quote) => quote.id === quoteId);
      if (index !== -1) {
        this.quotes[index] = updatedQuote;
      }
      if (this.quote?.id === quoteId) {
        this.quote = updatedQuote;
      }
    },
    removeQuote(quoteId: string) {
      this.quotes = this.quotes.filter((quote) => quote.id !== quoteId);

      if (this.quote?.id === quoteId) {
        this.quote = {} as MasterQuote;
      }
    },
  },
});
